import React = require("react")
import { PublicAmorgUser, Activity } from "../../../amorg-common";
import { Button } from "../../../designSystem/button/Button";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { Modal } from "../../../designSystem/Modal";
import { ParticipantEditor } from "./ParticipantEditor";
import { InfoChip } from "../../../designSystem/Chip";

type ActivityParticipantListProps = {
    users: PublicAmorgUser[];
    activity: Activity;
    noParticipantText? : string;
    onParticipantsUpdated(): void;
}
export function ActivityParticipantList(props: ActivityParticipantListProps): JSX.Element {

    const [showUserModal, setShowUserModal] = React.useState(false);

    return (
        
            <Flex flexDirection="row" gap={16}>

                <Flex flexDirection="row" alignItems="center" gap={4} flexWrap="wrap">
                    {props.activity.participants.length === 0 && <i>{props.noParticipantText ?? 'Ingen valgt'}</i>}

                    {props.activity.participants.map(p => {
                        return (
                            <>
                                <InfoChip variant="outlined" key={p.id}>{p.name}</InfoChip>
                            </>
                        );
                    })}
                    <Button variant="text" onClick={()=>setShowUserModal(true)} icon="interface_actions_edit" />
                </Flex>


                <Modal 
                    title={"Rediger deltagere"}
                    content={
                        <ParticipantEditor
                            activity={props.activity}
                            defaultAddRole="participant"
                            onParticipantsUpdated={props.onParticipantsUpdated}
                            onCancel={() => setShowUserModal(false)} />
                    }
                    showModal={showUserModal}
                    onCancel={() => setShowUserModal(false)}/>
               
            </Flex>
    );
}